<template>
  <div class="priviewFileCom clearfix">
    <div class="hasimg" v-for="(item,index) in images" :key="index">
      <div class="hasimg__inner" v-if="(item != '') && /\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)">
        <img class="showCon" :src="oss_url+item.url + '?x-oss-process=image/resize,m_fill,h_90,w_90,limit_0'" alt="加载失败"/>
        <div class="ckdt" style="cursor: pointer;" @click="ckdt(oss_url+item.url)">
          <div style="width: 100%;height: 100%;position: relative;"></div>
          <div style="position: relative;top: -60px;">查看大图</div>
        </div>
      </div>
      <span class="rrq" :title="item.name">{{item.name}}</span>
      <el-button @click="download(item.name,oss_url+item.url)">下载</el-button>
    </div>
    <div class="hasimg" v-for="(item,index) in files" :key="index">
      <div class="hasimg__inner" v-if="(item != '') && /\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)">
        <img class="showCon" :src="oss_url+item.url + '?x-oss-process=image/resize,m_fill,h_90,w_90,limit_0'" alt="加载失败" />
        <div class="ckdt" style="cursor: pointer;" @click="ckdt(oss_url+item.url)">
          <div style="width: 100%;height: 100%;position: relative;"></div>
          <div style="position: relative;top: -60px;">查看大图</div>
        </div>
      </div>
      <div class="hasimg__inner" v-else-if="(item != '') && /\.mp4$/i.test(item.url)" style="cursor: pointer;" @click="paly(item.url)">
        <img :src="oss_url + item.url + '?x-oss-process=video/snapshot,t_0,f_jpg,w_90,h_90,m_fast'" class="common__video__snaphot">
        <img src="../../assets/image/play.png" class="common__video__cover">
        <video :src="oss_url+item.url" webkit-playsinline="true" playsinline="true" x5-playsinline="true">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="hasimg__inner" v-else-if="item != ''">
        <div class="file_icon" :style='{background:fileBack[item.type.substring(0,1).charCodeAt()%5]}'>{{item.type.substring(0,1).toUpperCase()}}</div>
      </div>
      <span class="rrq" :title="item.name">{{item.name}}</span>
      <span v-if="(item != '') && /\.pdf$/i.test(item.url)" style="display: flex; height: 30px; box-sizing: border-box;">
        <a class="rrq noprint" style="display:block; text-decoration:none; margin-right: 10px;" @click="download(item.name,oss_url+item.url)">下载</a>
        <a class="rrq noprint" style="display:block; text-decoration:none;" @click="previewPDF(item)">预览</a>
      </span>
      <el-button v-else @click="download(item.name,oss_url+item.url)">下载</el-button>
    </div>
    <maximg ref="max"></maximg>
    <div class="look_video" v-if="isShow">
      <i class="el-icon-close look_video_close" @click="closeVideo"></i>
      <video width="100%" height="100%" controls>
        <source :src="oss_url + url" type="video/mp4">
        您的浏览器不支持 video 标签。
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'previewFilesCom',
  data() {
    return {
      fileBack:['#fe9940','#409dfe','#eb5e5e','#1fbf41','#679bf4'],
      isShow: false,
      url: ''
    };
  },
  props: ['img_arr', 'file_arr', 'oss_domain'],
  computed: {
    images() {
      let arr = this.img_arr;
      if ((typeof(arr) === "string") && (arr !== '')) {
        arr = JSON.parse(arr);
      }
      if (!arr) {
        arr = []
      }
      return arr;
    },
    files() {
      let arr = this.file_arr;
      if ((typeof(arr) === "string") && (arr !== '')) {
        arr = JSON.parse(arr);
      }
      if (!arr) {
        arr = []
      }
      return arr;
    },
    oss_url() {
      return this.oss_domain || this.img_oss;
    },
  },
  mounted(){
    this.$nextTick(function(){
      let m = document.getElementsByClassName('rrq');
      for (let i = 0; i < m.length; i++) {
        $clamp(m[i], { clamp: 2 });
      }
    });
  },
  methods: {
    previewPDF(item) {
      let routeurl = this.$router.resolve({ path: '/pdfpreview', query: {
        url: this.oss_url+item.url,
        title: item.name,
      }, });
      window.open(routeurl.href, '_blank');
    },
    ckdt(url){//查看大图
      let urls = [];
      this.images.forEach(item => {
        if (/\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)) {
          urls.push(this.oss_url + item.url);
        }
      });
      this.files.forEach(item => {
        if (/\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)) {
          urls.push(this.oss_url + item.url);
        }
      });
      let index = urls.findIndex(o => o == url);
      if (index != -1) {
        this.$refs.max.openImgsDialog(index, urls);
      }
    },
    async download(name,url){ // 下载
      let response = await fetch(url)
      // 内容转变成blob地址
      let blob = await response.blob()
      // 创建隐藏的可下载链接
      let objectUrl = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.style.display = "none";
      //地址
      a.href = objectUrl
      //修改文件名
      a.download = name
      // 触发点击
      document.body.appendChild(a)
      a.click()
      //移除
      URL.revokeObjectURL(a.href);
    },
    // 播放视频
    paly(url) {
      this.isShow = true;
      this.url = url;
    },
    // 关闭视频
    closeVideo() {
      this.isShow = false;
    }
  },
}
</script>

<style lang="scss" scoped>
.priviewFileCom {
  overflow: hidden;
  .noimg{
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
    border: 1px solid #ebeef5;
    background: #f6f6f6 ;
    background-size: contain;
    position: relative;
    float: left;
    margin-right: 20px;
    text-align: center;
    a {
      color: #409dfe;
      line-height: 100px;
    }
    .file_input {
      width: 100%;
      height: 100%;
      z-index: 999;
      right: 0;
      cursor: pointer;
      position: absolute;
      margin-top: 0px;
      opacity: 0;
      top:0;
    }
  }
  .hasimg{
    width: 100px;
    margin-bottom: 20px;
    text-align: center;
    vertical-align: middle;
    float: left;
    margin-right: 20px;
    >div{
      width: 100%;height: 100px;position: relative;
      border: 1px solid #ebeef5;
      text-align: center;
      line-height: 100px;
    }
    .file_icon{
      color:#fff;
      font-weight: bold;
      font-size: 30px;
    }
    img{
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
    >span{
      line-height: 20px;
      word-break: break-all;
      word-wrap: break-word;
      display: block;
      height: 40px;
    }
    span.rrq{
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: ignore next*/
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
    }
    a.rrq{
      line-height: 30px;
      border: 1px solid #409dfe;
      color: #409dfe;
      cursor: pointer;
      width: 80%;
      margin: 0 auto;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: ignore next*/
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
    }
    .ckdt{
      display: none;
      width: 100%;height: 100%;
      position: absolute;
      z-index: 100;
      left: 0;
      top: 0;
      text-align: center;
      line-height: 20px;
      color: #fff;
      font-size: 14px;
      background: rgba(0,0,0,0.4);
      span{
        cursor: pointer;
      }
      em{
        cursor: pointer;
        position: absolute;
        display: block;
        width:20px;
        height: 20px;
        right: 10px;
        top: 10px;
        background: url("../../assets/image/zgdelete.png")  no-repeat center top;
      }
    }
    .hasimg__inner{
      position: relative;
      video {
        max-width: 100%;
        max-height: 100%;
        object-fit: fill;
        opacity: 0;
      }
      .common__video__cover{
        position: absolute;
        left: 22%;
        top: 22%;
        display: block;
        width: 50px;
        height: 50px;
      }
    }
    .hasimg__inner:hover{
      .ckdt{
        display: block;
      }
    }
  }
  .look_video{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5000;
    background: rgb(0, 0, 0);
    .look_video_close{
      position: absolute;
      right: 20px;
      color: #FFF;
      font-size: 40px;
      top: 20px;
      cursor: pointer;
      z-index: 9999;
    }
    .look_video{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewFiles/PreviewFiles.vue